/**
 *
 * BranchShiftForm
 *
 */
import { RootState } from 'controller/types';
import { SubmitButton } from 'core/components/SetupComponents/SubmitButton';
import { Input } from 'core/components/Input';
import { error } from 'core/components/Notify';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { useOutsideAlerter } from 'core/hooks/useOutsideClickDetect';
import { convertTimeIntoObj } from 'core/utils/constants/DateTime';
import { BranchShift } from 'core/utils/types/modules/org';
import { useBranchSetupSlice } from 'features/BranchSetup/slice';
import React, { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components/macro';
import {
  TimePicker,
  convertDateToTime,
} from 'core/components/DateTimePicker';
import moment from 'moment';
import { isValidInput } from 'core/utils/constants';

interface Props {
  values?: BranchShift;
  action?: string;
  onNext?: () => void;
}

export const BranchShiftForm = memo((props: Props) => {
  const authData = useAuth();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.branchSetup);
  const { actions } = useBranchSetupSlice();
  const params = useParams();
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  const [values, setvalues] = React.useState<BranchShift>({
    NAME: '',
    START_TIME: props?.values?.START_TIME
      ? props?.values?.START_TIME
      : '07:00',
    END_TIME: props?.values?.END_TIME
      ? props?.values?.END_TIME
      : '14:00',
  } as BranchShift | any);


  // console.log('init', values)

  /* Calendar related */
  const [startDate, setstartDate] = React.useState<Date | undefined>(undefined);
  const [endDate, setendDate] = React.useState<Date | undefined>(undefined);
  const [hideCalendarStart, sethideCalendarStart] =
    React.useState<boolean>(true);
  const [hideCalendarEnd, sethideCalendarEnd] = React.useState<boolean>(true);

  const refCalendarStart = useRef<HTMLDivElement>(null);
  const refCalendarStartMenu = useRef<HTMLDivElement>(null);
  useOutsideAlerter(refCalendarStart, refCalendarStartMenu, () =>
    sethideCalendarStart(true),
  );

  const refCalendarEnd = useRef<HTMLDivElement>(null);
  const refCalendarEndMenu = useRef<HTMLDivElement>(null);
  useOutsideAlerter(refCalendarEnd, refCalendarEndMenu, () =>
    sethideCalendarEnd(true),
  );

  const handleInputChange = e => {
    const { name, value } = e.target;
    setvalues({
      ...values,
      [name]: value,
    });
    setIsDirty(true);
  };

  React.useEffect(() => {
    if (state?.navigate){
      props?.onNext && props?.onNext();
      dispatch(actions.setNavigate(false));
    }
  },[state?.navigate])

  const onSubmit = e => {
    e.preventDefault();
    if (
      !moment(values?.START_TIME, 'hh:mm').isBefore(
        moment(values?.END_TIME, 'hh:mm'),
      )
    ) {
      error('End Time should be greater than Start Time', true);
      return;
    }
    dispatch(
      actions.createBranchSetupStart({
        URL: params?.url as string || 'branchShift',
        data: {
          ...values,
          BRANCH_ID: authData?.BRANCH_ID as number,
        },
        action: props.action || 'save',
        message: props.action
          ? 'Updated Successfully!'
          : 'Created Successfully!',
      }),
    );
    setIsDirty(false);
  };

  React.useEffect(() => {
    if (props.values?.BRANCH_SHIFT_ID) {
      setvalues(props.values as BranchShift);
      if (props.values.START_TIME) {
        setstartDate(convertTimeIntoObj(props.values.START_TIME) as any);
      }
      if (props.values.END_TIME) {
        setendDate(convertTimeIntoObj(props.values.END_TIME) as any);
      }
    }
  }, [props.values?.BRANCH_SHIFT_ID]);

  return (
    <Div onSubmit={onSubmit}>
      <div className="grid grid-cols-2 gap-[1vw] items-center">
        <Input
          name="NAME"
          placeholder="Shift Name"
          onChange={handleInputChange}
          value={values.NAME}
          width="w-[100%] mx-0"
          label="Title"
          required
          maxLength={45}
        />
        <div className="flex justify-center items-start gap-[1vw]">

          {/* <TimePicker
            label="Start Time"
            name={'START_TIME'}
            value={convertTimeIntoObj(values?.START_TIME) as any}
            required
            onChange={time => {
              const __V: any = { ...values };
              __V.START_TIME = convertTimeIntoObj(time, true);
              setvalues(__V);
            }}
          /> */}

            <Input
              type="time"
              // message={meta.touched && meta.error}
              label="Start Time"
              value={values?.START_TIME}
              onChange={handleInputChange}
              placeholder="Enter Text"
              name={'START_TIME'}
              // onBlur={field.onBlur}
              // error={meta.touched && meta.error}
              required
            />

            <Input
              type="time"
              // message={meta.touched && meta.error}
              label="End Time"
              value={values?.END_TIME}
              onChange={handleInputChange}
              placeholder="Enter Text"
              name={'END_TIME'}
              // onBlur={field.onBlur}
              // error={meta.touched && meta.error}
              required
            />
      
          {/* <TimePicker
            label={'End Time'}
            name={'END_TIME'}
            error={
              !moment(
                convertTimeIntoObj(values?.START_TIME, true),
                'hh:mm',
              ).isBefore(
                moment(convertTimeIntoObj(values?.END_TIME, true), 'hh:mm'),
              )
            }
            value={convertTimeIntoObj(values?.END_TIME) as any}
            required
            onChange={time => {
              const __V: any = { ...values };
              __V.END_TIME = convertTimeIntoObj(time, true);
              setvalues(__V);
             
            }}
          /> */}
        </div>
      </div>
      
      <div className='text-center'>
      <SubmitButton
        inputValidate={
          values &&
          ((values.NAME !== undefined && !values.NAME.length || !isValidInput(values.NAME)) ||
            (values.START_TIME !== undefined && !values.START_TIME.length) ||
            (values.END_TIME !== undefined && !values.END_TIME.length))
        }
        isDirty={isDirty}
      />
      </div>
    </Div>
  );
});

const Div = styled.form``;